const cardsData = [
  {
    title: '2025 暑期档必看大片',
    desc: '暑期档重磅集结，动作、科幻、动画全类型覆盖，精选十部年度必看电影推荐，陪你度过精彩夏天。',
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20movie%20themed%20illustration%20with%20warm%20summer%20vibes%2C%20featuring%20abstract%20film%20elements%2C%20soft%20golden%20and%20coral%20gradients%2C%20clean%20minimal%20composition%2C%20modern%20flat%20style%2C%20no%20text%2C%20simple%20background%20with%20subtle%20geometric%20patterns%2C%20warm%20tones&width=600&height=400&seq=xiaocao-card-1&orientation=landscape',
    tag: '专题推荐',
  },
  {
    title: '国产科幻崛起之路',
    desc: '从流浪地球到三体，中国科幻电影迎来黄金时代。盘点近年国产科幻佳作，见证中国电影工业飞跃。',
    img: 'https://readdy.ai/api/search-image?query=A%20futuristic%20sci-fi%20themed%20illustration%20with%20warm%20amber%20and%20deep%20coral%20tones%2C%20abstract%20space%20elements%2C%20clean%20minimal%20composition%2C%20modern%20flat%20illustration%20style%2C%20no%20text%2C%20simple%20background%20with%20subtle%20star-like%20patterns%2C%20cinematic%20mood&width=600&height=400&seq=xiaocao-card-2&orientation=landscape',
    tag: '影评盘点',
  },
  {
    title: '经典港片修复合辑',
    desc: '高清修复版经典港片上线，周星驰、成龙、周润发等巨星代表作，重温黄金年代的银幕记忆。',
    img: 'https://readdy.ai/api/search-image?query=A%20nostalgic%20retro%20cinema%20themed%20illustration%20with%20warm%20vintage%20amber%20tones%2C%20classic%20film%20elements%2C%20clean%20minimal%20composition%2C%20modern%20flat%20illustration%20style%2C%20no%20text%2C%20simple%20warm%20background%2C%20cinematic%20atmosphere&width=600&height=400&seq=xiaocao-card-3&orientation=landscape',
    tag: '经典回顾',
  },
  {
    title: '高分悬疑片单推荐',
    desc: '烧脑悬疑电影精选，从国产佳作到国际名导，每一部都让你猜不到结局，悬疑迷必收藏片单。',
    img: 'https://readdy.ai/api/search-image?query=A%20mysterious%20thriller%20themed%20illustration%20with%20warm%20deep%20coral%20and%20amber%20tones%2C%20abstract%20shadowy%20elements%2C%20clean%20minimal%20composition%2C%20modern%20flat%20illustration%20style%2C%20no%20text%2C%20simple%20dark%20background%20with%20subtle%20light%20accents%2C%20cinematic%20mood&width=600&height=400&seq=xiaocao-card-4&orientation=landscape',
    tag: '精选片单',
  },
  {
    title: '治愈系动漫合集',
    desc: '宫崎骏、新海诚等大师作品全收录，还有高分国漫推荐。适合放松解压的温暖动画，一次看个够。',
    img: 'https://readdy.ai/api/search-image?query=A%20warm%20anime-inspired%20illustration%20with%20soft%20coral%20and%20golden%20tones%2C%20floating%20clouds%20and%20gentle%20landscape%20elements%2C%20clean%20minimal%20composition%2C%20modern%20flat%20illustration%20style%2C%20no%20text%2C%20simple%20warm%20background%2C%20peaceful%20atmosphere&width=600&height=400&seq=xiaocao-card-5&orientation=landscape',
    tag: '动漫专区',
  },
  {
    title: '周末喜剧放松指南',
    desc: '精选国内外高分喜剧电影，从沈腾马丽到好莱坞经典，保证让你笑到停不下来，周末宅家必备片单。',
    img: 'https://readdy.ai/api/search-image?query=A%20cheerful%20comedy%20themed%20illustration%20with%20warm%20coral%20and%20golden%20tones%2C%20playful%20abstract%20elements%2C%20clean%20minimal%20composition%2C%20modern%20flat%20illustration%20style%2C%20no%20text%2C%20simple%20bright%20background%2C%20happy%20cinematic%20vibe&width=600&height=400&seq=xiaocao-card-6&orientation=landscape',
    tag: '轻松一刻',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">热门推荐</h2>
          <p className="text-sm text-foreground-500 max-w-[560px] mx-auto">精心策划的影视专题与片单合集，帮你快速找到想看的好内容。</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardsData.map((card, i) => (
            <article
              key={i}
              className="group rounded-xl bg-background-50 border border-background-200/60 overflow-hidden hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden bg-background-100">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const el = e.currentTarget;
                    el.style.display = 'none';
                  }}
                />
                <span className="absolute top-3 left-3 px-2 py-1 rounded-md text-[10px] font-medium bg-background-50/90 text-primary-600">
                  {card.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors mb-2">{card.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">{card.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}